import type { FallbackProps } from 'react-error-boundary';

import { ErrorPage } from './error-page';

export const MainErrorFallback = ({
  error,
  resetErrorBoundary,
}: Partial<FallbackProps>) => (
  <div className="h-screen w-screen">
    <ErrorPage error={error} onRetry={resetErrorBoundary} />
  </div>
);
